import React from 'react';

interface ContextType {
    notifications: any;
}

const NotificationContext = React.createContext<ContextType>({notifications: null});

export default NotificationContext;